import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PageTabRail } from '../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../components/router/router-tabbed-navigation';
import {
  RaglStockBlotterTable,
  type RaglStockBlotterTableHeaderProps,
  type RaglStockBlotterTableViewContext,
} from '../../../../../../../../features/clearing-ledger/delta/ragl-stock-blotter-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsReporting,
      label: 'Stock Blotter',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsReporting>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'stock-blotter',
        label: 'Reports',
        to: '/clearing/operations/reporting/stock-blotter',
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Stock Blotter'),
  component: StockBlotter,
});

function TableHeader({ filter }: RaglStockBlotterTableHeaderProps) {
  return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingOperationsReporting} />;
}

const VIEW_CONTEXT: RaglStockBlotterTableViewContext = { kind: 'blotter' };

function StockBlotter() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglStockBlotterTable HeaderActions={TableHeader} viewContext={VIEW_CONTEXT} />
      </PageLayout.Section>
    </PageLayout>
  );
}
